/**
 * Created by m.igrachev on 6/19/2017.
 */
const documentedProperties = [
    {
        name: "smartBlur",
        type: "Function",
        defaultValue: "true",
        isRequired: "false",
        description:
            "If set to false, onBlur will be triggered regardless if the value was changed."
    },
    {
        name: "onFocus",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description: "A callback function to be called when component is focused in."
    },
    {
        name: "onBlur",
        type: "Function",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "A callback function to be called when component is focused out and its value was changed since the last focus in."
    }
];

export default documentedProperties;
